import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { Dialog, DialogContent } from "@b2bportal/core-ui";
import { useDeviceType } from "@b2bportal/core-utilities";
import { CalendarPicker, FlightSearch } from "@tenant/flights";
import { DateSelectionButton } from "../DateSelectionButton";
import { LocationSelectionButton } from "../LocationSelectionButton";
import defaultStyles from "./FlightShopSearch.module.scss";
import { useFlightShopSearch } from "./hooks";

export const FlightShopSearch = () => {
  const COMPONENT_KEY = CoreFlightsComponent.FlightShopSearch;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { isDesktopAndUp } = useDeviceType();

  const {
    context: { openMobileSearch, openCalendar },
    handlers: {
      onClose,
      handleOnSearch,
      onDateSelectionClick,
      onLocationSelectionClick,
    },
  } = useFlightShopSearch();

  return (
    <div className={block}>
      {isDesktopAndUp ? (
        <FlightSearch />
      ) : (
        <div>
          <div className={cn("mobile")}>
            <div className={cn("location-selection-button-container")}>
              <LocationSelectionButton onClick={onLocationSelectionClick} />
            </div>
            <div className={cn("date-selection-button-container")}>
              <DateSelectionButton onClick={onDateSelectionClick} />
            </div>
          </div>
          <Dialog open={openMobileSearch}>
            <DialogContent fullScreen={true} onClose={onClose}>
              <FlightSearch
                className={cn("search", { calendar: openCalendar })}
                onSearch={handleOnSearch}
                showCalendarBackButton={true}
              />
            </DialogContent>
          </Dialog>
          <CalendarPicker
            open={openCalendar}
            onSearch={handleOnSearch}
            onClose={onClose}
          />
        </div>
      )}
    </div>
  );
};
